import { defineComponent as _defineComponent } from 'vue'
import BCXTextArea from '@/components/molecules/forms/BCXTextArea.vue';
import { useVModel } from '@vueuse/core';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BCXActionBoxMessageBox',
  props: {
  title: {
    type: String,
    default: ''
  },
  value: {
    type: String,
    default: ''
  },
  placeholder: {
    type: String,
    default: ''
  },
  disabled: {
    type: Boolean // todo: disable-bar machen
  }
},
  emits: ['send', 'update:value'],
  setup(__props, { emit }) {

const props = __props;

const isMessengerEnlarged = ref(false);




const vModel = useVModel(props);

return { __sfc: true,isMessengerEnlarged, emit, props, vModel, BCXTextArea }
}

})